module.exports = __webpack_public_path__ + "img/rent-1.2e88c2dc.png";